export enum INTERVENTION_TEMPLATES_SORTS {}

export enum INTERVENTION_TEMPLATES_FILTERS {
  ASSOCIABLE = "filter[associable]",
  ID = "filter[id]",
  INTERVENTION_TYPE_ID = "filter[intervention_type_id]",
  LATEST = "filter[latest]",
  REVISIONS_OF = "filter[revisions_of]",
}
